import { Component, Input, OnInit } from '@angular/core';
import { ConsoleService } from 'src/app/services/console/console.service';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import {SafeStyle , DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-widget-categories',
    templateUrl: './widget-categories.component.html',
    styleUrls: ['./widget-categories.component.scss'],
})
export class WidgetCategoriesComponent implements OnInit {
    @Input() widgetTitle: any;
    @Input() widgetID: any;
    @Input() regionId: any;

    categories: any[] = [];
    widgetStyle:any;
    itemStyle:any;
    background:any ;
    style:any;

    constructor(private widgetsService: WidgetsService, private consoleService: ConsoleService,private domSanitizer:DomSanitizer) { }


    async ngOnInit() {
        let widgetData: any = await this.widgetsService.getWidgetData(this.widgetID);
        this.consoleService.consoleLog('widget-catg-comp:27', widgetData)
        if(widgetData && widgetData.style){
            this.style = widgetData.style;
        }
        if (widgetData && widgetData.style && widgetData.style.widgetStyle && Object.keys(widgetData.style.widgetStyle).length != 0) {
            this.widgetStyle = widgetData.style.widgetStyle;
            this.consoleService.consoleLog('widget-categories:28 - this.widgetStyle', this.widgetStyle) 
            if(this.widgetStyle.backgroundImage){
                this.background = this.domSanitizer.bypassSecurityTrustStyle(`url(${this.widgetStyle.backgroundImage})`);
                //this.consoleService.consoleLog('widget-product-list.component.html:64 - backgroundImage', this.backgroundImage) 
            }
            else if(this.widgetStyle.backgroundColor){
                this.background = this.widgetStyle.backgroundColor;
            }
            else{
                //this.background = 'transparent';
            }
        }
        if (widgetData && widgetData.style && widgetData.style.itemStyle && Object.keys(widgetData.style.itemStyle).length != 0) {
           this.itemStyle = widgetData.style.itemStyle;
        }

        if (widgetData && widgetData.categoryList && widgetData.categoryList.length) {
            widgetData.categoryList.forEach(async id => {
                const category: any = await this.widgetsService.getCBSDataFromId(id, 'categories');
                if (category) {
                    if (this.regionId) {
                        if (category.regionId && category.regionId.length && category.regionId.includes(this.regionId)) {
                            this.categories.push({ id, ...category });
                        }
                    } else {
                        this.categories.push({ id, ...category });
                    }
                }
            });
        }
    }

}
